<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="cu_code,cu_name"
      placeholder="输入代理商编号、名称进行查找"
      ref="searchBar"
    />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="{name: 'AgentClientvisit', params: { item }}"
      >
        <div class="weui-cell__bd">
          <p>{{item.agentname}}</p>
          <p class="list-item-muted">{{item.agentcode}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'yyyy-MM-dd'">{{item.cv_date}}</p>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}条</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/agent/report/clientVisit",
    }
  },
}
</script>